module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA1BAMAAAAkBnF3AAAAD1BMVEXOESYAK3/80RZUYlvdUCC+xjniAAAAJklEQVRIx2MQRAZGSkhAhQEFjCocVTiqcFThqMJRhaMKRxVSQSEA6aGUCJuKIGMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/ro.png
// module id = o6+G
// module chunks = 2